function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.454 55c14.79 0 26.065-15.261 23.058-31.128C50.252 1.402 40.087 0 25.296 0S1.806 9.093.056 29.193C-1.14 42.97 16.663 55 31.454 55z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.25 18.333L21.083 27.5l9.167 9.167",
  stroke: "#8781bd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

function SvgLeftWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 55,
    width: 55
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjU1IiB2aWV3Qm94PSIwIDAgNTUgNTUiIHdpZHRoPSI1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzEuNDUzOCA1NWMxNC43OTEgMCAyNi4wNjUzLTE1LjI2MSAyMy4wNTc4LTMxLjEyNzUtNC4yNTkyLTIyLjQ2OTk2LTE0LjQyNTEtMjMuODcyNDk4MjUtMjkuMjE2MS0yMy44NzI0OTg4OS0xNC43OTA5LS4wMDAwMDA2NS0yMy40ODkxOCA5LjA5Mjc2ODg5LTI1LjIzODA5NiAyOS4xOTMwOTg4OS0xLjE5ODYxNCAxMy43NzU2IDE2LjYwNTQ5NiAyNS44MDY5IDMxLjM5NjM5NiAyNS44MDY5eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Im0zMC4yNDk5IDE4LjMzMzMtOS4xNjY2IDkuMTY2NyA5LjE2NjYgOS4xNjY2IiBzdHJva2U9IiM4NzgxYmQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+";
export { SvgLeftWhite as ReactComponent };